/* One Final Bite by JoJo — motion + cart helpers
   Uses GSAP + ScrollTrigger + Lenis when available; everything degrades gracefully. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  var gsap = window.gsap;
  var ST = window.ScrollTrigger;
  var inEditor = root.classList.contains('shopify-design-mode') || (window.Shopify && window.Shopify.designMode);

  if (gsap && ST && !reduce && !inEditor) root.classList.add('ofb-js');

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ofb-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* ---------- Add to cart ---------- */
  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    var name = btn.getAttribute('data-name') || 'Cookie';
    if (!id) return;
    btn.setAttribute('aria-busy', 'true');
    var done = function (ok) {
      btn.removeAttribute('aria-busy');
      if (!ok) { toast('Something went wrong. <a href="/cart">Open cart</a>'); return; }
      btn.classList.add('is-added');
      var label = btn.querySelector('.ofb-add__label');
      var prev = label ? label.textContent : '';
      if (label) label.textContent = 'Added';
      setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = prev; }, 1600);
    };
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && actions.updateCart) {
      actions.updateCart({ lines: [{ merchandiseId: id, quantity: 1 }] }, { event: { context: 'product' } })
        .then(function (res) {
          var ok = !(res && res.userErrors && res.userErrors.length);
          done(ok);
          if (ok && !document.querySelector('theme-drawer#cart-drawer')) toast(name + ' added. <a href="/cart">View cart</a>');
        })
        .catch(function () { fallback(); });
    } else {
      fallback();
    }
    function fallback() {
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function (r) {
        done(r.ok);
        if (r.ok) toast(name + ' added. <a href="/cart">View cart</a>');
      }).catch(function () { done(false); });
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ofb-add]');
    if (btn) { e.preventDefault(); addToCart(btn); }
    var copy = e.target.closest && e.target.closest('[data-ofb-copy]');
    if (copy) {
      var code = copy.getAttribute('data-ofb-copy');
      if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {});
      var old = copy.textContent;
      copy.textContent = 'Copied!';
      setTimeout(function () { copy.textContent = old; }, 1500);
    }
  });

  /* ---------- Sticky mobile CTA ---------- */
  var sticky = document.querySelector('.ofb-sticky');
  if (sticky) {
    var onScroll = function () {
      var y = window.scrollY || window.pageYOffset;
      var nearEnd = (window.innerHeight + y) > (document.body.scrollHeight - 500);
      sticky.classList.toggle('is-visible', y > 520 && !nearEnd);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (!gsap || !ST || reduce || inEditor) return;
  gsap.registerPlugin(ST);

  /* ---------- Lenis smooth scroll ---------- */
  var lenis = null;
  if (window.Lenis && window.matchMedia('(pointer: fine)').matches) {
    lenis = new window.Lenis({ duration: 1.1, smoothWheel: true, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); } });
    window.ofbLenis = lenis;
    lenis.on('scroll', ST.update);
    gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);
    var markPrevent = function () {
      document.querySelectorAll('dialog, theme-drawer, .cart-drawer, [role="dialog"], .menu-drawer, details-modal')
        .forEach(function (el) { el.setAttribute('data-lenis-prevent', ''); });
    };
    markPrevent();
    new MutationObserver(function () {
      var locked = getComputedStyle(document.body).overflow === 'hidden' || getComputedStyle(root).overflow === 'hidden' || document.querySelector('dialog[open]');
      if (locked) lenis.stop(); else lenis.start();
      markPrevent();
    }).observe(document.body, { attributes: true, attributeFilter: ['style', 'class'], subtree: false, childList: true });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || a.getAttribute('href') === '#') return;
      var target = document.querySelector(a.getAttribute('href'));
      if (target) { e.preventDefault(); lenis.scrollTo(target, { offset: -90 }); }
    });
  }

  /* ---------- Split text (React Bits "SplitText" style) ---------- */
  document.querySelectorAll('.ofb-split').forEach(function (el) {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    var walk = function (node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var w = document.createElement('span'); w.className = 'ofb-word';
            var i = document.createElement('span'); i.textContent = part;
            w.appendChild(i); frag.appendChild(w);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && !child.classList.contains('ofb-word')) {
          walk(child);
        }
      });
    };
    walk(el);
    var inner = el.querySelectorAll('.ofb-word > span');
    var isHero = !!el.closest('.ofb-hero, .ofb-lp-hero');
    var vars = { yPercent: 0, y: 0, duration: 1, ease: 'expo.out', stagger: 0.06, delay: isHero ? 0.15 : 0 };
    if (!isHero) vars.scrollTrigger = { trigger: el, start: 'top 85%' };
    gsap.fromTo(inner, { yPercent: 105, y: 0 }, vars);
  });

  /* ---------- Generic reveal ---------- */
  gsap.utils.toArray('[data-ofb-reveal]').forEach(function (el) {
    var group = el.closest('[data-ofb-stagger]');
    gsap.to(el, {
      opacity: 1, y: 0, duration: 0.9, ease: 'power3.out',
      delay: group ? Array.prototype.indexOf.call(group.querySelectorAll('[data-ofb-reveal]'), el) * 0.08 : 0,
      scrollTrigger: { trigger: group || el, start: 'top 88%' }
    });
  });

  /* ---------- Hero stage ---------- */
  var stage = document.querySelector('.ofb-stage');
  if (stage) {
    var cookies = stage.querySelectorAll('.ofb-stage__cookie');
    gsap.from(cookies, { scale: 0.4, opacity: 0, rotate: -90, duration: 1.4, ease: 'back.out(1.6)', stagger: 0.12, delay: 0.2 });
    gsap.from(stage.querySelector('.ofb-stage__plate'), { scale: 0.6, opacity: 0, duration: 1.2, ease: 'expo.out' });
    cookies.forEach(function (c, i) {
      gsap.to(c, { y: i % 2 ? 14 : -14, duration: 3 + i * 0.6, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: 1.4 });
      gsap.to(c.querySelector('img'), { rotate: i % 2 ? -360 : 360, duration: 60 + i * 12, ease: 'none', repeat: -1 });
    });
    stage.querySelectorAll('.ofb-stage__sprinkle').forEach(function (s, i) {
      gsap.to(s, { y: (i % 2 ? -1 : 1) * (30 + i * 8), rotate: '+=' + (90 + i * 20), duration: 4 + i, ease: 'sine.inOut', yoyo: true, repeat: -1 });
    });
    gsap.to(stage, { yPercent: 12, ease: 'none', scrollTrigger: { trigger: stage, start: 'top top', end: 'bottom top', scrub: true } });
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      cookies.forEach(function (c, i) {
        gsap.to(c, { x: x * (16 + i * 10), duration: 0.8, ease: 'power3.out', overwrite: 'auto' });
      });
    });
  }
  var hl = document.querySelector('.ofb-hero .ofb-hl');
  if (hl) gsap.fromTo(hl, { '--hl': 0 }, { '--hl': 1, duration: 1, ease: 'expo.out', delay: 0.9 });

  /* ---------- Marquee (velocity reactive) ---------- */
  document.querySelectorAll('.ofb-marquee__track').forEach(function (track) {
    var right = track.getAttribute('data-dir') === 'right';
    var tween = right
      ? gsap.fromTo(track, { xPercent: -50 }, { xPercent: 0, duration: 28, ease: 'none', repeat: -1 })
      : gsap.fromTo(track, { xPercent: 0 }, { xPercent: -50, duration: 28, ease: 'none', repeat: -1 });
    ST.create({
      trigger: track, start: 'top bottom', end: 'bottom top',
      onUpdate: function (self) {
        var v = Math.min(Math.abs(self.getVelocity()) / 400, 4);
        gsap.to(tween, { timeScale: 1 + v, duration: 0.2, overwrite: true });
        gsap.to(tween, { timeScale: 1, duration: 1.2, delay: 0.25 });
      }
    });
  });

  /* ---------- Tilted cards + magnet buttons (React Bits style) ---------- */
  if (window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('[data-ofb-tilt]').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        gsap.to(card, { rotateY: x * 10, rotateX: -y * 10, transformPerspective: 900, duration: 0.5, ease: 'power3.out' });
      });
      card.addEventListener('mouseleave', function () { gsap.to(card, { rotateX: 0, rotateY: 0, duration: 0.8, ease: 'elastic.out(1,0.5)' }); });
    });
    document.querySelectorAll('[data-ofb-magnet]').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        gsap.to(btn, { x: (e.clientX - r.left - r.width / 2) * 0.25, y: (e.clientY - r.top - r.height / 2) * 0.35, duration: 0.4, ease: 'power3.out' });
      });
      btn.addEventListener('mouseleave', function () { gsap.to(btn, { x: 0, y: 0, duration: 0.7, ease: 'elastic.out(1,0.4)' }); });
    });
  }

  /* ---------- Box fill animation ---------- */
  document.querySelectorAll('.ofb-boxviz').forEach(function (box) {
    var imgs = box.querySelectorAll('.ofb-boxviz__slot img');
    gsap.from(imgs, { y: -160, opacity: 0, rotate: -120, scale: 0.6, duration: 0.9, ease: 'bounce.out', stagger: 0.14, scrollTrigger: { trigger: box, start: 'top 75%' } });
    gsap.from(box.querySelector('.ofb-boxviz__lid'), { y: -30, opacity: 0, duration: 0.6, ease: 'back.out(2)', delay: 0.9, scrollTrigger: { trigger: box, start: 'top 75%' } });
  });

  /* ---------- Step numbers pop ---------- */
  gsap.utils.toArray('.ofb-step__num').forEach(function (n, i) {
    gsap.from(n, { scale: 0, rotate: -90, duration: 0.8, ease: 'back.out(2.2)', delay: i * 0.12, scrollTrigger: { trigger: n, start: 'top 88%' } });
  });

  /* ---------- Landing collage ---------- */
  gsap.utils.toArray('.ofb-lp-collage__item').forEach(function (it, i) {
    gsap.from(it, { scale: 0, opacity: 0, duration: 1, ease: 'back.out(1.7)', delay: 0.2 + i * 0.08 });
    gsap.to(it.querySelector('img'), { rotate: i % 2 ? -360 : 360, duration: 50 + i * 7, ease: 'none', repeat: -1 });
  });

  /* ---------- Price count-up ---------- */
  document.querySelectorAll('[data-ofb-count]').forEach(function (el) {
    var end = parseFloat(el.getAttribute('data-ofb-count'));
    var obj = { v: 0 };
    gsap.to(obj, { v: end, duration: 1.4, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 85%' }, onUpdate: function () { el.textContent = '$' + Math.round(obj.v); } });
  });

  window.addEventListener('load', function () { ST.refresh(); });
})();
